import { AfterViewInit, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-tab-navigation',
    templateUrl: './tab-navigation.component.html',
    styleUrls: ['./tab-navigation.component.scss'],
    standalone: false
})

export class TabNavigationComponent implements AfterViewInit {
  @Input() public tabs: string[];
  @Output() public tabNavigationClick = new EventEmitter<string>();

  public ngAfterViewInit(): void {
    this.tabClick(this.tabs[0]);
  }

  public tabClick(tabClicked: string): void {
    this.tabs.forEach(tab => {
      if (tab === tabClicked) {
        document.getElementById(tab).classList.add('navigation__tab--selected');
      } else {
        document.getElementById(tab).classList.remove('navigation__tab--selected');
      }
    });

    this.tabNavigationClick.emit(tabClicked);
  }
}
